<li class="hover:bg-gray-50 px-4 py-4 sm:px-6" (click)="showProviderEvent.emit(provider)">
  <div class="flex items-center space-x-4">
    <div class="flex-1 min-w-0">

      <p class="text-sm font-medium text-gray-900 truncate">
        {{provider?.name || ""}}
      </p>
      <p>
        {{provider?.website || ""}}
      </p>
    </div>

  </div>

</li>
